/*!
 * Copyright (c) 2015-2017 Cisco Systems, Inc. See LICENSE file.
 */

import {registerInternalPlugin} from '@ciscospark/spark-core';
import Flag from './flag';
import config from './config';
import '@ciscospark/internal-plugin-wdm';
import {has} from 'lodash';

registerInternalPlugin('flag', Flag, {
  config,
  payloadTransformer: {
    predicates: [
      {
        name: 'transformObjectArray',
        direction: 'inbound',
        test(ctx, response) {
          return Promise.resolve(has(response, 'body.multistatus'));
        },
        extract(response) {
          return Promise.resolve(response.body.multistatus.map((item) => item && item.data && item.data.activity));
        }
      }
    ],
    transforms: []
  }
});

export {default} from './flag';
